var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.211 23.167a2.34 2.34 0 002.334-2.333H6.878a2.333 2.333 0 002.333 2.333zm7-7v-5.833c0-3.582-1.913-6.58-5.25-7.374v-.793c0-.968-.781-1.75-1.75-1.75-.968 0-1.75.782-1.75 1.75v.793c-3.348.794-5.25 3.78-5.25 7.374v5.833L.706 17.672c-.735.735-.221 1.995.817 1.995h15.365c1.038 0 1.563-1.26.828-1.995l-1.505-1.505z",
    fill: "#353844"
  })));
}
export default __webpack_public_path__ + "media/images/notification-bell-202fb58a.svg";
export { SvgNotificationBell as ReactComponent };